import {getReportParams, report} from '../../../middleware/report';

export function dwhThirdPartyPopupDisplay(customerName, subscriber, contactId) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'My Zone';
  reportParams.channel = 'WebsitePrivate';
  reportParams.customerName = customerName;
  reportParams.actionType = 'Third Party Consent PopUp';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Third Party Consent PopUp Displayed';
  reportParams.subscriber = subscriber;
  reportParams.idNumber = contactId;
  reportParams.param1 = "";
  reportParams.param2 = '';
  report(reportParams);
}

export function dwhThirdPartyConfirm(customerName, subscriber, contactId) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'My Zone';
  reportParams.channel = 'WebsitePrivate';
  reportParams.customerName = customerName;
  reportParams.actionType = 'Third Party Consent PopUp';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Third Party Consent PopUp Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.idNumber = contactId;
  reportParams.param1 = "";
  reportParams.param2 = '';
  report(reportParams);
}

export function dwhThirdPartyError(customerName, subscriber, contactId) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'My Zone';
  reportParams.channel = 'WebsitePrivate';
  reportParams.customerName = customerName;
  reportParams.actionType = 'Third Party Consent PopUp';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.subscriber = subscriber;
  reportParams.idNumber = contactId;
  reportParams.param1 = "";
  reportParams.param2 = '';
  report(reportParams);
}

